import {
  SHOW_LOADER, HIDE_LOADER, CLEAR_ERROR, SHOW_MESSAGE, CLEAR_MESSAGE, OPEN_CONFIRMATION_DIALOG,
  CLOSE_CONFIRMATION_DIALOG, FETCH_COUNTRY_LIST, FETCH_COUNTRY_LIST_SUCCESS, FETCH_COUNTRY_LIST_ERROR,
  FETCH_REGION_LIST, FETCH_REGION_LIST_SUCCESS, FETCH_REGION_LIST_ERROR, FETCH_TIMEZONE_LIST,
  FETCH_TIMEZONE_LIST_SUCCESS, FETCH_TIMEZONE_LIST_ERROR, ERROR_MESSAGE_SKIPPED, OPEN_TEXT_CONFIRMATION_MODAL,
  CLOSE_TEXT_CONFIRMATION_MODAL, DISABLE_API_CACHE, ENABLE_API_CACHE,
  OPEN_RENAME_DEVICE_MODAL, CLOSE_RENAME_DEVICE_MODAL,
} from '../constants/ActionTypes';
import { Message, MessageType } from 'model/Message';
import { CustomAction } from 'model/state';
import { Country, Region } from 'model';
import { Timezone } from 'model/Timezone';
import i18n from 'i18next';

/**
 * Payload
 */
export interface CommonPayload {
  error?: string;
  message?: Message;
  metadata?: { [key: string]: any };
  countryId?: string | null;
  countries?: Country[];
  regions?: Region[];
  stateId?: string | null;
  timezones?: Timezone[];
}

/**
 * Actions
 */
export const showLoader = (): CustomAction<CommonPayload> => {
  return {
    type: SHOW_LOADER
  };
};

export const hideLoader = (): CustomAction<CommonPayload> => {
  return {
    type: HIDE_LOADER
  }
};

export const showError = (message: string, error?: any, description?: string): CustomAction<CommonPayload> => {
  if ([403, 404].includes(error?.response?.status)) {
    return {
      type: ERROR_MESSAGE_SKIPPED
    }
  }
  return {
    type: SHOW_MESSAGE,
    payload: { message: {
      type: MessageType.ERROR,
      message,
      description: description ? description : i18n.t('error_common_description')
    }}
  };
};

export const clearError = (): CustomAction<CommonPayload> => {
  return {
    type: CLEAR_ERROR
  }
};

export const showMessage = (message: Message): CustomAction<CommonPayload> => {
  return {
    type: SHOW_MESSAGE,
    payload: { message }
  };
};

export const clearMessage = (): CustomAction<CommonPayload> => {
  return {
    type: CLEAR_MESSAGE
  }
};

export const openConfirmationDialog = (metadata?: { [key: string]: any }): CustomAction<CommonPayload> => {
  return {
    type: OPEN_CONFIRMATION_DIALOG,
    payload: { metadata }
  }
};

export const closeConfirmationDialog = (): CustomAction<CommonPayload> => {
  return {
    type: CLOSE_CONFIRMATION_DIALOG
  }
};

export const openTextConfirmationModal = (metadata?: { [key: string]: any }): CustomAction<CommonPayload> => {
  return {
    type: OPEN_TEXT_CONFIRMATION_MODAL,
    payload: { metadata }
  }
};

export const closeTextConfirmationModal = (): CustomAction<CommonPayload> => {
  return {
    type: CLOSE_TEXT_CONFIRMATION_MODAL
  }
};

export const openRenameDeviceModal = (metadata?: { [key: string]: any }): CustomAction<CommonPayload> => {
  return {
    type: OPEN_RENAME_DEVICE_MODAL,
    payload: { metadata }
  }
};

export const closeRenameDeviceModal = (): CustomAction<CommonPayload> => {
  return {
    type: CLOSE_RENAME_DEVICE_MODAL
  }
};

export const fetchCountryList = (): CustomAction<CommonPayload> => {
  return {
    type: FETCH_COUNTRY_LIST,
  }
};

export const fetchCountryListSuccess = (countries: Country[]): CustomAction<CommonPayload> => {
  return {
    type: FETCH_COUNTRY_LIST_SUCCESS,
    payload: { countries }
  }
};

export const fetchCountryListError = (): CustomAction<CommonPayload> => {
  return {
    type: FETCH_COUNTRY_LIST_ERROR,
  }
};

export const fetchRegionList = (countryId: string | null): CustomAction<CommonPayload> => {
  return {
    type: FETCH_REGION_LIST,
    payload: { countryId }
  }
};

export const fetchRegionListSuccess = (regions: Region[]): CustomAction<CommonPayload> => {
  return {
    type: FETCH_REGION_LIST_SUCCESS,
    payload: { regions }
  }
};

export const fetchRegionListError = (): CustomAction<CommonPayload> => {
  return {
    type: FETCH_REGION_LIST_ERROR,
  }
};

export const fetchTimezoneList = (countryId: string | null, stateId: string | null): CustomAction<CommonPayload> => {
  return {
    type: FETCH_TIMEZONE_LIST,
    payload: { countryId, stateId }
  }
};

export const fetchTimezoneListSuccess = (timezones: Timezone[]): CustomAction<CommonPayload> => {
  return {
    type: FETCH_TIMEZONE_LIST_SUCCESS,
    payload: { timezones }
  }
};

export const fetchTimezoneListError = (): CustomAction<CommonPayload> => {
  return {
    type: FETCH_TIMEZONE_LIST_ERROR,
  }
};

export const disableApiCache = (): CustomAction<CommonPayload> => {
  return {
    type: DISABLE_API_CACHE,
  }
};

export const enableApiCache = (): CustomAction<CommonPayload> => {
  return {
    type: ENABLE_API_CACHE,
  }
};
